module.exports = __webpack_public_path__ + "static/media/no-select-exp.1bdbabb0f9d4689f87484ae6943fd506.png";